module.exports = __webpack_public_path__ + "static/media/p1-1.587b3e01.png";